import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查询个人付费详情
  getOrgTrialSkuConfig(_postData) {
    return http.get(URL.API_PAYMENT_GET_SKU_CONFIG, _postData)
  },
  // 查询机构套餐列表
  getFamilyCallOrgSku(_postData) {
    return http.get(URL.API_PAYMENT_GET_ORGSKU, _postData)
  },
  // 创建订单
  saveOrder(_postData) {
    return http.post(URL.API_PAYMENT_SAVE_ORDER, _postData)
  },
  // 获取订单列表
  getOrderList(_postData) {
    return http.get(URL.API_PAYMENT_GET_ORDER_LIST, _postData)
  },
  // 调用支付宝支付
  alipayPay(_postData) {
    return http.post(URL.API_PAYMENT_ALIPAY_PAY, _postData)
  },
  // 查询支付状态
  getOrderStatus(_postData) {
    return http.get(URL.API_PAYMENT_GET_ORDER_SRTATUS, _postData)
  },
  // 支付宝订单同步通知
  payOrdersyncNotice(_postData) {
    return http.get(URL.API_PAYMENT_ALIPAY_PAY_NOTICE, _postData)
  },
  // 查询是否是亲情通话付费机构
  getThirdPayOrg(_postData) {
    return http.get(URL.API_PAYMENT_THIRD_PAY_ORG, _postData)
  }
}
